import { ICountProjectDevices } from '../models/count-project-devices.model';
import { IProject, ProjectUser } from '../../shared/models/project.model';
import { User } from '../../shared/models/user';
import { IDocumentLoaderStates } from '../../shared/models/document.model';
import { SEVERITY_ERROR_MESSAGE, VALIDATION_FAILED_MESSAGE } from '../../shared/constants/project-form.constants';
import { IEnclosure, IEnclosureProjectOverview } from '../../shared/models/enclosure.model';
import { FilterProjectsPipe } from '../../home/pipes/filter-projects.pipe';
import  { ADD_TO_CART_ACTIONS } from '../../shared/models/analytics';

export const countDevices = (data: ICountProjectDevices) => {
  return data?.numberOfAccessories + data?.numberOfComponents + data?.numberOfDevices;
}

export const addOriginalSequencing = (projects: IProject[]): IProject[] => {
  if(!projects) {
    return;
  }
  for(let i = 0; i < projects.length; i++) {
    projects[i].originalSequence = i;
  }
  return projects;
}

export const userIsOwner = (user: User, projectOwner: ProjectUser) => {
  if (!user || !projectOwner) {
    return false
  }

  return user.email === projectOwner.email;
}

export const addProjectToList = (projectId: number, selectionArray: number[]): void => {
  if(!selectionArray) {
    return;
  }

  selectionArray?.push(projectId);
}

export const getAllUnAssignedProjects = (projects: IProject[]) => {
  return projects?.filter(project => !project.projectOwner && !project.isArchived) || [];
}

export const getDefaultDocumentLoaderStates = (): IDocumentLoaderStates => {
  return {
    bomWithPrice: false,
    bomWithPriceXL: false,
    bomWithOutPrice: false,
    bomWithOutPriceXL: false,
    enclosureLayout: false,
    enclosureLayoutWithCover: false,
    dispositionLayout: false,
    dispositionLayoutWithCover: false,
    labels: false,
    labelsBackSide: false,
    ratingPlate: false,
    ratingPlateXL: false,
    sld: false
  } as IDocumentLoaderStates;
}

export const editErrorTextMessage = (error) => {
  if(error?.details) {
    error.details = error?.details?.replace(VALIDATION_FAILED_MESSAGE, '').replace(SEVERITY_ERROR_MESSAGE,'');
  }
}

export const checkIfEnclosureIsConfigured = (enclosure: IEnclosure) => {
  if(!enclosure) {
    return false;
  }

  return enclosure?.productRangeId !== 0;
}

export const showProjectImplementationDateCalendarOnProjectOpen = (project: IProject, numberOfEnclosuresInProject: number): boolean => {
  // eslint-disable-next-line max-len
  return project && !project.installationDate && numberOfEnclosuresInProject === 0 && !project.isShared && !project.isArchived && !project.isInTenderingMode;
}

export const mapToEnclosure = (enclosures: IEnclosureProjectOverview[]): IEnclosure[] => {
  return enclosures.map(projectOverviewEnclosure => {
    return {
      enclosureId: projectOverviewEnclosure?.enclosureId,
      projectId: projectOverviewEnclosure?.projectId,
      productRangeId: projectOverviewEnclosure?.productRangeId,
      productRange: projectOverviewEnclosure?.productRange,
      name: projectOverviewEnclosure?.name,
      apartments: projectOverviewEnclosure?.apartments,
      enclosureSpecs: projectOverviewEnclosure?.enclosureSpecs,
      enclosureType: projectOverviewEnclosure?.enclosureType,
      enclosureDescription: projectOverviewEnclosure?.enclosureDescription,
      createdByCurrentUser: projectOverviewEnclosure?.createdByCurrentUser,
      product: projectOverviewEnclosure?.product,
      enclosureDateCreated: projectOverviewEnclosure?.enclosureDateCreated,
      enclosureDateUpdated: projectOverviewEnclosure?.enclosureDateUpdated,
      isSldConfigured: projectOverviewEnclosure?.isSldConfigured,

      description: '',
      devices: [],
      enclosureOptions: [],
      enclosureSpecId: 0,
      isCopied: false,
      isCurrent: 0,
      isSaved: false,
      optionstring: '',
      overrideRange: 0,
      productId: projectOverviewEnclosure?.product?.productId,
      reference: '',
      savedState: undefined,
    }
  })

}

export const getOrdinalNumberOfSearchedProject = (projects: IProject[], searchKeyword: string, projectId: number): number => {
  if (!projects?.length || !searchKeyword?.length) {
    return 0;
  }

  const positionIndex = new FilterProjectsPipe().transform(projects, searchKeyword)?.findIndex(project => project.projectId === projectId);

  if (positionIndex < 0) {
    return 0;
  }

  return positionIndex + 1;
}

export const getNameOfAddToCartActions = (hookUrl: string): string => {

  if (!hookUrl) {
    return '';
  }

  if (hookUrl.includes('sonepar')) {
    return ADD_TO_CART_ACTIONS.TRANSFER_TO_SONEPAR;
  }

  if (hookUrl.includes('elektrogrosshandel')) {
    return ADD_TO_CART_ACTIONS.TRANSFER_TO_ELEKTROGROSSHANDEL;
  }

  if (hookUrl.includes('elektro-material')) {
    return ADD_TO_CART_ACTIONS.TRANSFER_TO_ELEKTRO_MATERIAL;
  }

  return '';
}
